// deepcontext-6i0j.1 — the actions row, rendered inline above the list
// (ScheduledJobsPage no longer portals it into AppLayout's flex-shrink-0
// `app-page-actions` slot — that slot never grows past its content width, so
// a flex-1 search inside it can't actually go full width). Mirrors the
// Blueprints toolbar (SearchFilterBar.tsx): the bd-yj2sq pill search (or the
// bd-sh26v isolation band) takes the full-width search slot, then the Est.
// Daily Cost warn pill and the gradient Create Job button, both sized to
// match the search bar's height. The list already reloads on every SSE
// jobs_update event, so there is no separate Refresh.
import React from "react";
import SearchInput from "../ui/SearchInput";

interface JobsToolbarProps {
  isolatedJobId: string;
  isolatedJobName?: string;
  onClearIsolation: () => void;
  searchTerm: string;
  onSearchTermChange: (term: string) => void;
  isAdmin: boolean;
  onCreate: () => void;
  estimatedDailyCost: number;
}

const JobsToolbar: React.FC<JobsToolbarProps> = ({
  isolatedJobId,
  isolatedJobName,
  onClearIsolation,
  searchTerm,
  onSearchTermChange,
  isAdmin,
  onCreate,
  estimatedDailyCost,
}) => (
  // -mt-[21px] pulls the row's centerline up to match the sidebar's Explore
  // nav pill centerline (deepcontext-jlkv mechanism, deepcontext-fbj1.1 —
  // mirrors SearchFilterBar.tsx's Blueprints toolbar).
  <div className="-mt-[21px] flex flex-wrap items-center gap-3">
    {isolatedJobId ? (
      /* bd-sh26v — isolated to a single job via ?jobId deep-link. An
         accent-tinted band with a clear affordance replaces the search. */
      <div className="flex min-w-0 flex-1 items-center gap-3 rounded-full bg-nav-active px-4 py-1.5">
        <span className="text-xs text-accent-active">
          Showing one job
          {isolatedJobName ? `: ${isolatedJobName}` : " (not found)"}
        </span>
        <button
          type="button"
          onClick={onClearIsolation}
          className="text-xs font-bold text-accent-active underline hover:opacity-80"
        >
          Show all jobs
        </button>
      </div>
    ) : (
      /* bd-yj2sq — client-side search by job title or referenced blueprint. */
      <SearchInput
        className="flex-1"
        placeholder="Search jobs by title or blueprint..."
        value={searchTerm}
        onChange={(e) => onSearchTermChange(e.target.value)}
      />
    )}
    {/* deepcontext-hkt0.5 — h-[42px] (rather than py-2) pins the pill and the
        Create Job button to the app's 42px row-control standard, matching
        SearchInput and the Button `md` size (see _config/conventions.md)
        instead of the shorter ~36px py-2 chrome. */}
    <span className="inline-flex h-[42px] items-center whitespace-nowrap rounded-full bg-warn-bg px-4 text-sm font-extrabold tabular-nums text-warn">
      Est. Daily Cost · ${Number(estimatedDailyCost || 0).toFixed(2)}
    </span>
    {isAdmin && (
      <button
        type="button"
        onClick={onCreate}
        className="inline-flex h-[42px] items-center gap-1.5 rounded-full bg-gradient-accent px-4 text-sm font-bold text-white transition-opacity hover:opacity-90"
      >
        Create Job
      </button>
    )}
  </div>
);

export default JobsToolbar;
